<template>
  <svg
    width="32"
    height="20"
    viewBox="0 0 100 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fill-rule="evenodd">
      <rect width="100" height="60" rx="5" fill="#FFF" />
      <rect
        stroke="#000"
        stroke-width="1.5"
        x=".75"
        y=".75"
        width="98.5"
        height="58.5"
        rx="4"
      />
      <path d="M47.527 30.336v6.523h-2.07V20.74h5.49c1.39 0 2.575.464 3.548 1.39.99.927 1.486 2.057 1.486 3.391 0 1.366-.495 2.497-1.486 3.415-.96.918-2.144 1.374-3.548 1.374h-3.42v.025zm0-7.612v5.628h3.464c.819 0 1.508-.278 2.052-.83.555-.553.836-1.224.836-1.978 0-.74-.281-1.404-.836-1.957a2.776 2.776 0 0 0-2.052-.847h-3.464v-.016zM61.13 25.46c1.532 0 2.74.41 3.626 1.23.886.82 1.328 1.943 1.328 3.367v6.802h-1.978v-1.535h-.087c-.857 1.265-2.005 1.893-3.434 1.893-1.222 0-2.241-.36-3.06-1.084-.82-.722-1.231-1.624-1.231-2.708 0-1.146.434-2.054 1.302-2.724.866-.681 2.024-1.018 3.466-1.018 1.234 0 2.247.225 3.043.677v-.475c0-.722-.286-1.331-.86-1.835a2.94 2.94 0 0 0-2.014-.756c-1.166 0-2.087.49-2.762 1.476l-1.83-1.156c1.012-1.434 2.51-2.154 4.49-2.154zm-2.679 8.013c0 .54.23.99.69 1.346.456.356 1.001.54 1.617.54.876 0 1.658-.323 2.34-.97.685-.647 1.027-1.405 1.027-2.276-.654-.515-1.566-.776-2.733-.776-.853 0-1.56.205-2.13.612-.567.41-.811.913-.811 1.524zM77.224 25.819 70.235 41.86h-2.135l2.605-5.611-4.611-10.43h2.252l3.317 7.974h.05l3.243-7.974z" fill="#5F6368" fill-rule="nonzero" />
      <path d="M37.273 28.834c0-.674-.058-1.319-.166-1.939H28.49v3.535l4.94.001a4.211 4.211 0 0 1-1.83 2.815v2.288h2.946c1.717-1.59 2.728-3.945 2.728-6.7z" fill="#4285F4" fill-rule="nonzero" />
      <path d="M31.6 33.246a5.461 5.461 0 0 1-3.107.871c-2.388 0-4.41-1.604-5.137-3.77h-3.04v2.36a9.17 9.17 0 0 0 8.179 5.014c2.473 0 4.554-.81 6.066-2.207L31.6 33.246z" fill="#34A853" fill-rule="nonzero" />
      <path d="M23.072 28.59c0-.61.103-1.198.288-1.752v-2.36h-3.043a9.078 9.078 0 0 0-.001 8.226l3.043-2.361a5.469 5.469 0 0 1-.287-1.753z" fill="#FABB05" fill-rule="nonzero" />
      <path d="M28.493 23.066a4.96 4.96 0 0 1 3.501 1.36l2.61-2.595a8.81 8.81 0 0 0-6.111-2.366 9.17 9.17 0 0 0-8.179 5.013l3.043 2.36c.726-2.166 2.748-3.772 5.136-3.772z" fill="#E94235" fill-rule="nonzero" />
    </g>
  </svg>
</template>
<script>
export default {
  name: "GooglePayIcon"
}
</script>
